import { takeLatest, call, put, all, select } from "redux-saga/effects";
import {
  api,
  getWalletMetaDataV2,
  getWalletSummaryV2,
  getWalletTransactionsV2,
  getTransactionDispute,
} from "@services/api";
import { actions } from "@reducers/walletReducer";
import {
  GET_DISPUTE,
  GET_MODAL_REQ,
  GET_WALLET_METADATA_REQ,
  GET_WALLET_SUMMARY_REQ,
  GET_WALLET_TRANSACTIONS_REQ,
} from "@reducers/actionTypes";
import { WalletTxnType } from "@screens/Wallet/v2/utils";
import { format } from "date-fns";

const getCurrentTimeFilter = (state: any) =>
  state.walletReducer.currentTimeFilter;
const getCurrentTransactionFilter = (state: any) =>
  state.walletReducer.currentTransactionFilter;
const getWalletTxnType = (state: any) => state.walletReducer.walletTxnType;
const getTimeFilter = (state: any) => state.walletReducer.timeFilters;
const getTransactionFilter = (state: any) =>
  state.walletReducer.transactionFilters;

const getTransactionType = (state: any) => state.walletReducer.transactionType;
const getModalApi = (state: any) => state.walletReducer.modalApi;
const getTransactionOffset = (state: any) => state.walletReducer?.walletTransactions?.nextOffset;

function* getWalletSummaryWorker() {
  yield put(actions.setLoading(true));
  try {
    const timeFilter: any = yield select(getCurrentTimeFilter);
    const walletTxnsType: WalletTxnType = yield select(getWalletTxnType);
    const { data } = yield call(() =>
      getWalletSummaryV2({
        type: walletTxnsType,
        toDate:
          timeFilter?.key === "CUSTOM"
            ? format(timeFilter?.toDate, "yyyy-MM-dd")
            : "",
        fromDate:
          timeFilter?.key === "CUSTOM"
            ? format(timeFilter?.fromDate, "yyyy-MM-dd")
            : "",
        TIME: timeFilter?.key,
      }),
    );

    yield put(actions.getWalletSummarySuccess(data));
  } catch (e) {
    console.log(e);
    yield put(actions.getWalletSummaryFail(e));
  } finally {
    yield put(actions.setLoading(false));
  }
}

function* getWalletTransactionsWorker(action) {
  yield put(actions.setLoading(true));
  try {
    const timeFilter: any = yield select(getCurrentTimeFilter);
    const transactionFilter: any = yield select(getCurrentTransactionFilter);
    const transactionType: any = yield select(getTransactionType);
    const transactionOffset: any = yield select(getTransactionOffset);

    const { limit, offset } = {limit: action?.params?.limit || 20, offset: action?.params?.offset || transactionOffset || 0}

    const { data } = yield call(() =>
      getWalletTransactionsV2({
        type: transactionType,
        toDate:
          timeFilter?.key === "CUSTOM"
            ? format(timeFilter?.toDate, "yyyy-MM-dd")
            : "",
        fromDate:
          timeFilter?.key === "CUSTOM"
            ? format(timeFilter?.fromDate, "yyyy-MM-dd")
            : "",
        TIME: timeFilter?.key,
        TRANSACTION: transactionFilter?.key,
        limit,
        offset,
      }),
    );

    yield put(actions.getWalletTransactionsSuccess(data, offset > 0));
  } catch (e) {
    console.log(e);
    yield put(actions.getWalletTransactionsFail(e));
  } finally {
    yield put(actions.setLoading(false));
  }
}

function* getDisputeWorker(action) {
  yield put(actions.setLoading(true));
  try {
    const txn_id = action.txn_id;
    const { data }: any = yield call(getTransactionDispute, txn_id);
    yield put(actions.getDisputeSuccess(data));
  } catch (error) {
    yield put(actions.getDisputeFail(error));
  } finally {
    yield put(actions.setLoading(false));
  }
}

function* getWalletMetaData() {
  // const timeFilter: any = yield select(getTimeFilter);
  // const transactionFilter: any = yield select(getTransactionFilter);
  // if (timeFilter?.length !== 0 && transactionFilter?.length !== 0) {
  //   return;
  // }
  try {
    const { data } = yield call(() => getWalletMetaDataV2());
    yield put(actions.getWalletMetaDataSuccess(data));
  } catch (e) {
    console.log(e);
    yield put(actions.getWalletMetaDataFail(e));
  }
}

function* getModalData() {
  yield put(actions.setModalLoading(true));
  try {
    const modalApi: any = yield select(getModalApi);
    const apiData = yield call(api, modalApi);
    yield put(actions.getModalSuccess(apiData?.data));
  } catch (e) {
    console.log(e);
    yield put(actions.getModalFail(e));
  } finally {
    yield put(actions.setModalLoading(false));
  }
}

export default function* walletSaga() {
  yield all([
    takeLatest(GET_WALLET_SUMMARY_REQ, getWalletSummaryWorker),
    takeLatest(GET_WALLET_METADATA_REQ, getWalletMetaData),
    takeLatest(GET_WALLET_TRANSACTIONS_REQ, getWalletTransactionsWorker),
    takeLatest(GET_DISPUTE, getDisputeWorker),
    takeLatest(GET_MODAL_REQ, getModalData),
  ]);
}
